var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "40",
        height: "39",
        viewBox: "0 0 40 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_40_4)" } }, [
        _c("path", {
          attrs: {
            d: "M17.5099 27.2879C19.4221 27.3645 21.3167 26.8961 22.9729 25.9374C24.8941 26.0961 26.6869 26.3257 28.2063 26.6127C33.9867 27.6458 35.6141 35.5533 35.6141 38.4638H0C0 35.5533 1.62742 27.6593 7.40778 26.6127C8.9204 26.3392 10.7436 26.1096 12.6783 25.9374C14.1496 26.7868 15.8114 27.2513 17.5099 27.2879",
            fill: "#0384FB",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M17.807 24.9751C22.6068 24.9751 26.4978 20.8861 26.4978 15.842C26.4978 10.7979 22.6068 6.70886 17.807 6.70886C13.0072 6.70886 9.11621 10.7979 9.11621 15.842C9.11621 20.8861 13.0072 24.9751 17.807 24.9751Z",
            fill: "#0384FB",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M21.0113 0V14.38C21.0085 14.6864 21.0795 14.989 21.2181 15.2623C21.3568 15.5355 21.5592 15.7714 21.8081 15.95L30.6981 22.1693L39.2336 15.9534C39.4743 15.7728 39.669 15.5381 39.8022 15.2683C39.9353 14.9985 40.0031 14.7011 40.0001 14.4003V0H21.0113Z",
            fill: "#00263E",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M35.9487 7.03521L30.0737 13.8894L26.416 10.8414L27.4004 9.66014L29.8931 11.7374L34.7813 6.03455L35.9487 7.03521Z",
            fill: "white",
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_40_4" } }, [
          _c("rect", {
            attrs: { width: "40", height: "38.4401", fill: "white" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }